import { HealthApi } from '@api/api';
import { inject, injectable } from 'inversify';
import type { AxiosError } from 'axios';

@injectable()
export class SecurityService {
	public constructor(@inject(HealthApi)
	private readonly healthApi: Readonly<HealthApi>) { }

	public async validateAndStoreCode(code: string): Promise<boolean> {
		let validationResult = false;

		try {
			this.setCode(code);
			const result = await this.healthApi.getHealthStatus();
			validationResult = result.status !== 403;
		} catch (error) {
			if ((error as AxiosError).response?.status === 403) {
				validationResult = false;
			} else {
				throw error;
			}
		}

		if (validationResult) {
			return validationResult;
		}
		this.removeCode();

		return validationResult;
	}

	// eslint-disable-next-line @typescript-eslint/class-methods-use-this
	public getPasscode(): string | null {
		return localStorage.getItem('passcode');
	}

	// eslint-disable-next-line @typescript-eslint/class-methods-use-this
	public setCode(passcode: string): void {
		localStorage.setItem('passcode', passcode);
	}

	// eslint-disable-next-line @typescript-eslint/class-methods-use-this
	public removeCode(): void {
		localStorage.removeItem('passcode');
	}

	// eslint-disable-next-line @typescript-eslint/class-methods-use-this
	public hasCode(): boolean {
		const result = localStorage.getItem('passcode');

		return result !== null;
	}
}
